import { get, post, put, del } from "./http";
import { BaseUrlNew } from "./NewSiteUrl";
import { headerDemo } from "./editHeader";

// ++++++++++ 活动形式-特价 ++++++++++

// 获取特价商品列表
export const getSpecialOfferGoodsList = params =>post("/ActivityService/Activity/GetSpecialOfferGoodsList",params);
// 活动特价商品排序
export const getSortedSpecialGoodsList = params =>post("/ActivityService/Activity/GetSortedSpecialGoodsList",params);
// 删除活动特价商品
export const getRemoveSpecialOfferGoods = params =>post("/ActivityService/Activity/RemoveSpecialOfferGoods",params);


// ++++++++++ 活动形式-秒杀 ++++++++++

// 查询秒杀商品列表
export const getSeckillGoodsList = params =>post("/ActivityService/Activity/GetSeckillGoodsList",params);
// 秒杀商品排序
export const getSortedSeckillGoodsList = params =>post("/ActivityService/Activity/GetSortedSeckillGoodsList",params);
// 移除秒杀商品
export const getRemoveSeckillGoods = params =>post("/ActivityService/Activity/RemoveSeckillGoods",params);


// ++++++++++ 活动形式-团购 ++++++++++

// 查询团购商品列表
export const getGroupBuyGoodsList = params =>post("/ActivityService/Activity/GetGroupBuyGoodsList",params);
// 团购商品排序
export const getSortedGroupBuyGoodsList = params =>post("/ActivityService/Activity/GetSortedGroupBuyGoodsList",params);
// 移除团购商品
export const getRemoveGroupBuyGoods = params =>post("/ActivityService/Activity/RemoveGroupBuyGoods",params);


// ++++++++++ 活动形式-优惠券 ++++++++++

// 获取活动优惠券列表
export const getlistcoupon = params =>post( BaseUrlNew + "/api/activity/coupon/getlist",params, headerDemo, 1, '1.0');
// 优惠券排序操作
export const getSortedCouponList = params =>post("/ActivityService/Activity/GetSortedCouponList",params);
// 移除活动优惠券
export const getRemoveCoupon = params =>post("/ActivityService/Activity/RemoveCoupon",params);
// 批量设置共创端推广佣金上限
export const getBatchUpdateCouponCommissionLimit = params =>post("/ActivityService/Activity/BatchUpdateCouponCommissionLimit",params);


// ++++++++++ 活动形式-预约签到礼 ++++++++++

// 获取预约签到礼商品列表
export const getReservationGoodsList = params =>post("/ActivityService/Activity/GetReservationGoodsList",params);
// 预约签到礼商品排序
export const getSortedReservationGoodsList = params =>post("/ActivityService/Activity/GetSortedReservationGoodsList",params);
// 删除活动预约签到礼商品
export const getRemoveReservationGoods = params =>post("/ActivityService/Activity/RemoveReservationGoods",params);
// 点击新增按钮时检查预约礼是否可以被创建
export const getCheckReservationGoodsIsAllowToInsert = params =>post("/ActivityService/Activity/CheckReservationGoodsIsAllowToInsert",params);


// ++++++++++ 活动形式-到店打卡礼 ++++++++++

// 到店打卡礼列表
export const getToStoreGiftList = params =>get( BaseUrlNew + "/api/activity/toStoreGiftList",params, 1, '1.0');
// 删除到店打卡礼
export const delToStoreGift = (params, newId) =>del( BaseUrlNew + "/api/activity/toStoreGift?id=" + newId, params, 1, '1.0');


// ++++++++++ 活动形式-连单礼 ++++++++++

// 连单礼列表
export const getContinuityOrderList = params =>get( BaseUrlNew + "/api/activity/continuityOrderList",params, 1, '1.0');
// 删除连单礼
export const delContinuityOrderGift = (params, newId) =>del( BaseUrlNew + "/api/activity/continuityOrderGift?id=" + newId, params, 1, '1.0');


// ++++++++++ 活动形式-特价商品 ++++++++++

// 分页获取活动店铺已选商品
export const specialpriceGetchoosegoods = params =>post( BaseUrlNew + "/api/activity/specialprice/getchoosegoods",params, headerDemo, 1, '1.0');
// 删除指定商品
export const specialpriceDelgoods = params =>del( BaseUrlNew + "/api/activity/specialprice/delgoods",params, 1, '1.0');


// ++++++++++ 活动形式-幸运购 ++++++++++

// 获取商品列表
export const smackerGetchoosegoods = params =>post( BaseUrlNew + "/api/activity/smacker/getchoosegoods",params, headerDemo, 1, '1.0');
// 添加活动商品
export const smackerSavegoods = params =>post( BaseUrlNew + "/api/activity/smacker/savegoods",params, headerDemo, 1, '1.0');
// 删除活动商品
export const smackerDelgoods = params =>del( BaseUrlNew + "/api/activity/smacker/delgoods",params, 1, '1.0');
// 活动商品排序（上移&下移）
export const smackerGoodssort = params =>put( BaseUrlNew + "/api/activity/smacker/goodssort",params, headerDemo, 1, '1.0');


// ++++++++++ 活动形式-小标题 ++++++++++

// 小标题列表
export const xiaobiaotiList = params =>get( BaseUrlNew + "/api/activity/image/list",params, 1, '1.0');
// 新增小标题
export const addXiaobiaoti = params =>post( BaseUrlNew + "/api/activity/image/add",params, headerDemo, 1, '1.0');
// 回显小标题
export const infoXiaobiaoti = (params, newId) =>get( BaseUrlNew + "/api/activity/image/info/"+newId,params, 1);
// 编辑小标题
export const editXiaobiaoti = params =>post( BaseUrlNew + "/api/activity/image/update",params, headerDemo, 1, '1.0');
// 删除小标题
export const delXiaobiaoti = params =>post( BaseUrlNew + "/api/activity/image/del",params, headerDemo, 1, '1.0');

// 保存活动形式
export const activitytypesave = params =>post( BaseUrlNew + "/api/activity/activitytype/save",params, headerDemo, 1, '1.0');
// 保存活动基本信息
export const basesave = params =>post( BaseUrlNew + "/api/activity/base/save",params, headerDemo, 1, '1.0');
// 获取活动基本信息
export const basegetinfo = (params, newId) =>get( BaseUrlNew + "/api/activity/base/getinfo/"+newId,params, 1);
// 重置活动签到礼配置数据
export const configreset = params =>post( BaseUrlNew + "/api/activity/signin/reset",params, headerDemo, 1, '1.0');
// 校验签到礼是否配置
export const signinverify = params =>get( BaseUrlNew + "/api/activity/signin/verify",params, 1, '1.0');
// 签到礼活动配置
export const configsignin = params =>post( BaseUrlNew + "/api/activity/signin/config",params, headerDemo, 1, '1.0');
// 获取活动形式详情
export const activitytypegetinfo = (params, oneId,twoId) =>get( BaseUrlNew + "/api/activity/activitytype/getinfo/"+oneId+'/'+twoId,params, 1);



// 完成活动
export const getActivityComplete = params =>post("/ActivityService/Activity/ActivityComplete",params);
export const getActivityeXplain = params =>post("/ActivityService/Activity/GetActivityeXplain",params);
// 获取创客分享奖现金活动详情
export const configtaskType = (params, newId) =>get( BaseUrlNew + "/api/task/config/"+newId,params, 1);
// 保存创客分享奖现金活动配置
export const configSave = params =>post( BaseUrlNew + "/api/task/config/save",params, headerDemo, 1, '1.0');
// 删除分享赚钱配置
export const delPeizhi = params =>post( BaseUrlNew + "/api/task/config/del",params, headerDemo, 1, '1.0');



// ++++++++++ 店铺管理 ++++++++++

// 获取装修公司店铺主页（回显）
export const getDcHome = params => get(BaseUrlNew + '/api/brandBusiness/dcHome', params, 1, '4.0');
// 编辑装修公司店铺主页
export const putDcHome = params =>put( BaseUrlNew + "/api/brandBusiness/dcHome",params, headerDemo, 1, '4.0');

// ++++++++++ 商家联盟 ++++++++++
// 推广记录列表（新接口）
export const getRechargeRecord = params => get(BaseUrlNew + '/api/activity/rechargeRecord', params, 1, '1.0');
// 推广记录汇总信息（新接口）
export const getRechargeInfo = params => get(BaseUrlNew + '/api/activity/rechargeInfo', params, 1, '1.0');
// 活动退款
export const postActivityRechargeRefunds = (params, tgjlId) => post( BaseUrlNew + "/api/weChatServerPay/activityRechargeRefunds?activityId=" + tgjlId, params, headerDemo, 1, '1.0');
// 查询活动是否已充值
export const getIsRecharge = params => get(BaseUrlNew + '/api/activity/isRecharge', params, 1, '1.0');
// 获取任务统计记录集合
export const poststatistics = params => post( BaseUrlNew + "/api/task/statistics",params, headerDemo, 1, '1.0');
// 生成活动预览码
export const activityPreview = params => post( BaseUrlNew + "/api/activity/preview",params, headerDemo, 1, '1.0');


// ++++++++++ 平台/商家 - 活动管理 ++++++++++

// 获取基础数据-省市
export const getAllProvinceAndCityList = params => post("/BaseDataNew/Province/GetAllProvinceAndCityList", params);
// 获取活动状态
export const getActivityStatus = params => post("/ActivityService/ActivityExamine/GetActivityStatus", params);
// 获取活动列表
export const getActivityList = params =>post("/ActivityService/ActivityExamine/GetActivityList",params);
// 报名记录
export const getActivityRegistrationRecord = params =>post("/ActivityService/ActivityExamine/GetActivityRegistrationRecord",params);
// 获取活动转换订单列表
export const getActivityConvertOrder = params =>post("/ActivityService/ActivityExamine/GetActivityConvertOrder",params);
// 获取活动转换订单统计
export const getActivityConvertStatistics = params =>post("/ActivityService/ActivityExamine/GetActivityConvertStatistics",params);
// 开启活动
export const getOpenActivity = params =>post("/ActivityService/ActivityExamine/OpenActivity",params);
// 关闭活动
export const getCloseActivity = params =>post("/ActivityService/ActivityExamine/CloseActivity",params);
// 物料
export const getGeneratedActivityQrCode = params =>post("/wxService/QRCode/GeneratedActivityQrCode",params);
// 复制活动
export const getCopyActivity = params =>post("/ActivityService/ActivityExamine/CopyActivity",params);

// 活动提交审核
export const getSubmitExamine = params =>post("/ActivityService/ActivityExamine/SubmitExamine",params);
// 活动撤销审核
export const getRevokeExamine = params =>post("/ActivityService/ActivityExamine/RevokeExamine",params);
// 删除活动
export const getDeleteActivity = params => post( BaseUrlNew + "/api/activity/del",params, headerDemo, 1, '1.0');

// 获取审核商家列表
export const getBusinessExamineActivityList = params => post("/ActivityService/ActivityExamine/GetBusinessExamineActivityList", params);
// 活动审核状态
export const getExamineStatus = params => post("/ActivityService/ActivityExamine/GetExamineStatus", params);
// 获取审核商家
export const getExamineBusiness = params => post("/ActivityService/ActivityExamine/GetExamineBusiness", params);
// 商家活动审核通过
export const getExamineSuccess = params => post("/ActivityService/ActivityExamine/ExamineSuccess", params);
// 商家活动审核驳回
export const getExamineFail = params => post("/ActivityService/ActivityExamine/ExamineFail", params);


// ++++++++++ 优惠券 ++++++++++

// 普通优惠券列表
export const getCoupons = params =>get( BaseUrlNew + "/api/Coupons",params, 1, '1.0');
// 活动优惠券列表
export const getActivityCoupons = params =>get( BaseUrlNew + "/api/Coupons/activityCoupons",params, 1, '1.0');
// 幸运购优惠券列表
export const getHappyDecorationCoupons = params =>get( BaseUrlNew + "/api/Coupons/happyDecorationCoupons",params, 1, '1.0');
// 新增优惠券
export const postCouponsAdd = params => post( BaseUrlNew + "/api/Coupons/add",params, headerDemo, 1, '1.0');
// 优惠券开启/关闭
export const postCouponschangestatus = params => post( BaseUrlNew + "/api/Coupons/changestatus",params, headerDemo, 1, '1.0');
// 获取优惠券（编辑回显）
export const getUpdateCoupoon = (params, couponId) =>get( BaseUrlNew + "/api/Coupons/detail/"+couponId,params, 1);
// 修改优惠券
export const postCouponsEdit = params => post( BaseUrlNew + "/api/Coupons/edit",params, headerDemo, 1, '1.0');
// 获取优惠券领取记录
export const getCouponsgetrecord = (params, couponId) =>get( BaseUrlNew + "/api/Coupons/getrecord/"+couponId,params, 1);
// 获取优惠券转换订单统计
export const getCoupoonConvertStatistics = params =>post("/Coupons/Coupons/GetCoupoonConvertStatistics",params);
// 获取优惠券转换订单列表
export const getCoupoonConvertOrder = params =>post("/Coupons/Coupons/GetCoupoonConvertOrder",params);
// 判断用户是否是超级管理员或甄惠装员工
export const getUserIsAdminOrTZRStaff = params =>post("/userService/Staff/UserIsAdminOrTZRStaff",params);
// 获取商家代理的品类品牌级联列表
export const getActivityExibitionBrandsForBrandBusiness = params =>post("/ActivityService/Activity/GetActivityExibitionBrandsForBrandBusiness",params);
// 获取有效品牌商
export const getEffectiveBrandBusiness = params =>get( BaseUrlNew + "/api/brandBusiness/effectiveBrandBusiness",params, 1, '4.0');
// 活动数据优惠券列表
export const getActivityDataCoupons = params =>get( BaseUrlNew + "/api/Coupons/activityDataCoupons",params, 1, '1.0');
// 获取优惠券（查看）
export const getSeeCoupoon = params =>post("/Coupons/Coupons/GetSeeCoupoon",params);
// 获取优惠券认购记录列表
export const getGrantCoupoon = params =>post("/Coupons/Coupons/GetGrantCoupoon",params);
// 活动签到礼领取记录列表
export const activitysignuprecored = params =>get( BaseUrlNew + "/api/activity/activitysignuprecored",params, 1, '1.0');

// 获取活动形式集合
export const activityformactivityType = (params, newId) =>get( BaseUrlNew + "/api/config/activityform/"+newId,params, 1);


// WEBPACK FOOTER //
// ./src/api/activityFormList.js